import FolderOutlined from "@mui/icons-material/FolderOutlined";
import { Box, Card, CardActionArea, CardContent, Chip, Stack, Typography } from "@mui/material";
import { useDragState } from "./hooks/use-drag-state";

import type { Folder } from "./server/folder-service";
import type { CardProps } from "@mui/material";
import type { DragEvent, FC } from "react";

export const FolderCard: FC<
  {
    folder: Folder;
    onClick: () => void;
  } & CardProps
> = ({ folder, onClick, onDragStart, onDragEnd, onDragOver, onDragLeave, onDrop, ...props }) => {
  const { isDragging, showDropHighlight, handlers } = useDragState<HTMLDivElement>({
    // oxlint-disable-next-line typescript/no-unsafe-type-assertion
    onDragStart: onDragStart as (event: DragEvent<HTMLDivElement>) => void,
    // oxlint-disable-next-line typescript/no-unsafe-type-assertion
    onDragEnd: onDragEnd as (event: DragEvent<HTMLDivElement>) => void,
    // oxlint-disable-next-line typescript/no-unsafe-type-assertion
    onDragOver: onDragOver as (event: DragEvent<HTMLDivElement>) => void,
    // oxlint-disable-next-line typescript/no-unsafe-type-assertion
    onDragLeave: onDragLeave as (event: DragEvent<HTMLDivElement>) => void,
    // oxlint-disable-next-line typescript/no-unsafe-type-assertion
    onDrop: onDrop as (event: DragEvent<HTMLDivElement>) => void,
  });

  return (
    <Card
      variant="outlined"
      {...props}
      onDragStart={handlers.handleDragStart}
      onDragEnd={handlers.handleDragEnd}
      onDragOver={handlers.handleDragOver}
      onDragLeave={handlers.handleDragLeave}
      onDrop={handlers.handleDrop}
      onClick={onClick}
      sx={[
        {
          cursor: props.draggable ? (isDragging ? "grabbing" : "grab") : undefined,
          opacity: isDragging ? 0.5 : 1,
          outline: showDropHighlight ? "2px solid" : "none",
          outlineColor: "primary.main",
          outlineOffset: -2,
        },
        ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
      ]}
    >
      <CardActionArea
        sx={{
          cursor: props.draggable ? "inherit" : undefined,
        }}
      >
        <Box
          role="img"
          sx={{
            height: "200px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
          }}
        >
          <FolderOutlined sx={{ width: "128px", height: "128px", color: "primary.main" }} />
        </Box>

        <CardContent>
          <Stack spacing={2}>
            <Typography variant="subtitle1" noWrap sx={{ textOverflow: "ellipsis" }}>
              {folder.name}
            </Typography>
            <Stack direction="row" sx={{ justifyContent: "space-between", alignItems: "center" }}>
              <Chip label="Folder" />
            </Stack>
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};
